module.exports = __webpack_public_path__ + "img/Group 27486.f4e98747.png";